import script from "./TressOrderSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressOrderSummary.vue?vue&type=script&lang=ts&setup=true"

import "./TressOrderSummary.vue?vue&type=style&index=0&id=15a63c4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a63c4e"]])

export default __exports__